import { render, staticRenderFns } from "./MailBodyContent.vue?vue&type=template&id=5ad0ad32"
import script from "./MailBodyContent.vue?vue&type=script&lang=js"
export * from "./MailBodyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports